import React, { createElement } from 'react';
import './index.css';
(function () {
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(preconnect);
  const preloadImg = document.createElement('link');
  preloadImg.rel = 'preload';
  preloadImg.as = 'image';
  preloadImg.href = 'https://cdn.magicpatterns.com/uploads/p5uukvc9r3hYXLcg8oon7N/PROYECTOS-Anuales-_1080-x-900-px_-_5_.webp';
  preloadImg.type = 'image/webp';
  (preloadImg as any).fetchPriority = 'high';
  document.head.insertBefore(preloadImg, document.head.firstChild);
})();
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-296" />, document.getElementById('root'));